import "./Home.module.css";
import VoltMainHeader from "@/reusable_sections/Header";
import KhoiDauKyNguyenGiaoThuongSo from "./sections/KhoiDauKyNguyenGiaoThuongSo";
import ProcesoDeReclutamiento from "./sections/ProcesoDeReclutamiento";
import WhyChooseUs from "./sections/WhyChooseUs";
import VisualPoetry from "./sections/VisualPoetry";
import ReviewStatisticsBanner from "./sections/ReviewStatisticsBanner";
import VoicesOfTheEvening from "./sections/VoicesOfTheEvening";
import ReadyToTakeControl from "./sections/ReadyToTakeControl";
import LocationAndServiceAreasRepairService from "@/reusable_sections/Footer";
import PricingHero from "./sections/PricingHero";
export default function HomePage() {
  return <div>
      <VoltMainHeader />
      <KhoiDauKyNguyenGiaoThuongSo />
      <PricingHero />
      <ProcesoDeReclutamiento />
      <WhyChooseUs />
      <VisualPoetry />
      <ReviewStatisticsBanner />
      <VoicesOfTheEvening />
      <ReadyToTakeControl />
      <LocationAndServiceAreasRepairService />
    </div>;
}